import styled from "@emotion/styled";
import { FC, ReactNode } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  border-left: 4px solid var(--Accessible-Blue, #3973da);
  background: rgba(171, 212, 255, 0.24);
  text-align: left;
`;

const Title = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.02em;
  color: var(--Greys-Charcoal, #212121);
`;

const InfoBox: FC<{ title: ReactNode; children?: ReactNode }> = (props) => (
  <Container>
    <Title>{props.title}</Title>
    {props.children && <div>{props.children}</div>}
  </Container>
);

export default InfoBox;
